import { Stack, Typography } from "@mui/material";
import MetricValueCardDouble from ".";
import { WellnessScoreStatus } from "../types";
import IconLoader from "@/features/Common/components/IconLoader";

export default function MetricValueCardDoubleExamples() {
  return (
    <Stack gap={3} width="100%">
      <MetricValueCardDouble
        metricName="Current wellbeing scores:"
        lastUpdated="2025-02-23T00:00:00Z"
        ctaText="Retake assessment"
        onCtaClick={() => console.log("CTA clicked")}
        metrics={[
          {
            label: "Depression",
            value: "0",
            unit: "points",
            status: WellnessScoreStatus.NeedsAttention,
            statusLabel: "Moderate depression",
            children: (
              <Stack
                sx={{
                  backgroundColor: "secondary.100",
                  borderRadius: 2,
                  p: 2,
                }}
                flexDirection="row"
                gap={1.5}
              >
                <IconLoader icon="FlagIcon" color="secondary" />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: 1.5,
                    color: "neutral.700",
                  }}
                >
                  Your score suggests you may be experiencing increased
                  emotional strain or reduced overall wellbeing.
                </Typography>
              </Stack>
            ),
          },
          {
            label: "Anxiety",
            value: "2",
            unit: "points",
            status: WellnessScoreStatus.NeedsAttention,
            statusLabel: "Moderate anxiety",
            children: (
              <Stack
                sx={{
                  backgroundColor: "secondary.100",
                  borderRadius: 2,
                  p: 2,
                }}
                flexDirection="row"
                gap={1.5}
              >
                <IconLoader icon="FlagIcon" color="secondary" />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: 1.5,
                    color: "neutral.700",
                  }}
                >
                  Your score indicates a higher level of tension or worry than
                  usual.
                </Typography>
              </Stack>
            ),
          },
        ]}
      />

      <MetricValueCardDouble
        metricName="Blood Pressure History"
        lastUpdated="2025-02-20T00:00:00Z"
        ctaText="View full history"
        onCtaClick={() => console.log("CTA clicked")}
        metrics={[
          {
            label: "Systolic",
            value: "127",
            unit: "mmHg",
            status: WellnessScoreStatus.NeedsAttention,
            statusLabel: "Elevated",
          },
          {
            label: "Diastolic",
            value: "76",
            unit: "mmHg",
            status: WellnessScoreStatus.Healthy,
            statusLabel: "Normal",
          },
        ]}
      />

      <MetricValueCardDouble
        metricName="Vitals Summary"
        ctaText="Update vitals"
        onCtaClick={() => console.log("CTA clicked")}
        metrics={[
          {
            label: "Heart Rate",
            value: "72",
            unit: "bpm",
            status: WellnessScoreStatus.Healthy,
            statusLabel: "Normal",
          },
          {
            label: "Breathing Rate",
            value: "18",
            unit: "breaths/min",
            status: WellnessScoreStatus.Healthy,
            statusLabel: "Normal",
          },
        ]}
      />
    </Stack>
  );
}
